// import {useEffect, useState} from "react";
// import {OfferCard, OfferCardTech} from "../../components/offer/Card";
// import {useFetchOffers} from "../../../hooks/useOffers";
// import Loader from "../../components/shared/Loader";
// import {useInView} from "react-intersection-observer";
// import {
//   interventionStatus,
//   offerStatus,
//   userRoleList,
// } from "../../../utils/constants";
// import {useMe} from "../../../hooks/useGetUser";
// import imageAvancement from "../../../images/AvancementProfile.png";
import arrow from "../../../images/arrowIntervention.png";
import BgPattern from "../../../images/BG-Pattern.png";
// import Weather from "../../components/shared/Weather";
// import FilterCard from "../../components/offer/filterCard";
// import StarIcon from "../../../images/icons/starIcon";
// import ImageComponent from "../../components/shared/ImageComponent";
// import {baseImageUrl} from "../../../services/AxiosInstance";
import NoProfile from "../../../images/profileImage.png";
// import Crown from "../../../images/crownIcon.svg";
// import useUserSectors from "../../../hooks/useUsersSectors";
// import ListCardOffer from "../../components/offer/ListCard";
// import InterventionItem from "../../components/offer/interventionItem";
// import {useDailyIntervention} from "../../../hooks/useInterventions";
// import {interventionStatusOptions} from "../../../utils/status";
// import {simpleDate} from "../../../utils/date";
// import {Link} from "react-router-dom";
// import ProfileCompletion from "../../components/Profile/ProfileCompletion";

import {useEffect, useState} from "react";
import {useMe} from "../../../hooks/useGetUser";
import {useDailyIntervention} from "../../../hooks/useInterventions";
import {simpleDate} from "../../../utils/date";
import {accountStatus, interventionStatus} from "../../../utils/constants";
import {Link, Navigate} from "react-router-dom";
import StarIcon from "../../../images/icons/starIcon";
import ImageComponent from "../../components/shared/ImageComponent";
import {buildImageUrl} from "../../../utils/imageUrlBuilder";
import Weather from "../../components/shared/Weather";
import InterventionItem from "../../components/offer/interventionItem";
import ListPrestataires from "./listCardPrestataire";
import FilterPrestataire from "./filterprestataire";
import Loader from "../../components/shared/Loader";
import {Dropdown} from "react-bootstrap";
import DropdownToggle from "react-bootstrap/esm/DropdownToggle";
import DropdownMenu from "react-bootstrap/esm/DropdownMenu";
import arrowTri from "../../../images/Tri.png";
import AutoComplete from "../../components/shared/autoCompleteInput";
import {
  useGetCatgeory,
  useGetSectors,
  useGetSubCategories,
} from "../../../hooks/useCategory";
import {useFetchPrestataires} from "../../../hooks/usePrestatires";
import PubList from "../../components/shared/PubList";
import {getPostcodesWithinRadius} from "../../../utils/geo";
import {requestCurrentPosition} from "../../../utils/geolocation";
import {useTranslation} from "react-i18next";

const NEARBY_RADIUS_KM = 10;
let postalDataPromise;

const loadPostalData = () => {
  if (!postalDataPromise) {
    postalDataPromise = fetch("/data/laposte_hexasmal_sorted.json").then(
      (response) => {
        if (!response.ok) throw new Error("POSTAL_DATA_UNAVAILABLE");
        return response.json();
      },
    );
  }
  return postalDataPromise;
};

const RecherchePrestataires = () => {
  const {t} = useTranslation();
  const [searchValue, setsearchValue] = useState("");
  const {data, isLoading: isMeLoading} = useMe();

  const {
    data: sectors,
    isError: isErrorSector,
    isLoading: isLoadSectors,
  } = useGetSectors();
  const {
    data: categories,
    isError: isErrorCat,
    isLoading: isLoadCat,
  } = useGetCatgeory();

  const {
    data: subCategories,
    isError: isErrorSubCat,
    isLoading: isLoadSubCat,
  } = useGetSubCategories();

  const {
    prestataires,
    isLoading: isLoadingPres,
  } = useFetchPrestataires({
    size: 20,
    filter: {status: [accountStatus.VALID]},
    order: "avgRating_DESC",
    search: searchValue,
    enabled: searchValue.trim().length >= 2,
  });
  const today = new Date();
  const TriOptions = [
    {titleKey: "bestRated", value: "avgRating", defaultOrder: "DESC"},
    {
      titleKey: "missionCount",
      value: "missionCount",
      defaultOrder: "DESC",
    },
    {titleKey: "seniority", value: "createdAt", defaultOrder: "ASC"},
  ];
  const [selectedTri, setSelectedTri] = useState(TriOptions[0]);
  const [selectedOrder, setSelectedOrder] = useState(
    TriOptions[0].defaultOrder,
  );
  const [searchTerm, setSearchTerm] = useState("");

  const {interventions, isError, isLoading} = useDailyIntervention({
    size: 5,
    filter: {
      startDate: simpleDate(today),
      status: [
        interventionStatus.NEW,
        interventionStatus.PROCESSING,
        interventionStatus.REPORTED,
      ],
    },
    order: [["startDate", "ASC"]],
  });
  const [groupSearch, setGroupSearch] = useState([
    {group: "secteurs", items: []},
    {group: "categories", items: []},
    {group: "subCategories", items: []},
    {group: "prestataires", items: []},
  ]);

  const [filter, SetFilter] = useState({
    size: 8,
    order: "avgRating_DESC",
    filter: {status: [accountStatus.VALID]},
    search: "",
  });
  const [nearbyStatus, setNearbyStatus] = useState("inactive");
  const [nearbyError, setNearbyError] = useState("");
  const [previousInterventionAreas, setPreviousInterventionAreas] = useState(
    [],
  );

  useEffect(() => {
    if (!isLoadSectors && !!sectors) {
      setGroupSearch((prev) => {
        const newArray = [
          {group: "secteurs", items: sectors},
          {...prev[1]},
          {...prev[2]},
          {...prev[3]},
        ];
        return [...newArray];
      });
    }
    if (!isLoadCat && !!categories) {
      setGroupSearch((prev) => {
        const newArray = [
          {...prev[0]},
          {group: "categories", items: categories},
          {...prev[2]},
          {...prev[3]},
        ];
        return [...newArray];
      });
    }
    if (!isLoadSubCat && !!subCategories) {
      setGroupSearch((prev) => {
        const newArray = [
          {...prev[0]},
          {...prev[1]},
          {group: "subCategories", items: subCategories},
          {...prev[3]},
        ];
        return [...newArray];
      });
    }
    if (isLoadingPres) {
      setGroupSearch((prev) => [
        {...prev[0]},
        {...prev[1]},
        {...prev[2]},
        {group: "prestataires", items: []},
      ]);
    } else if (prestataires) {
      setGroupSearch((prev) => {
        const newArray = [
          {...prev[0]},
          {...prev[1]},
          {...prev[2]},

          {group: "prestataires", items: prestataires.pages},
        ];
        return [...newArray];
      });
    }
  }, [
    sectors,
    categories,
    prestataires,
    subCategories,
    isLoadSubCat,
    isLoadingPres,
    isLoadSectors,
    isLoadCat,
  ]);

  const disableNearbySearch = () => {
    SetFilter((previousFilter) => ({
      ...previousFilter,
      filter: {
        ...previousFilter.filter,
        interventionAreas: previousInterventionAreas,
      },
    }));
    setNearbyStatus("inactive");
    setNearbyError("");
  };

  const enableNearbySearch = async () => {
    setNearbyStatus("loading");
    setNearbyError("");

    try {
      const [position, postalData] = await Promise.all([
        requestCurrentPosition(),
        loadPostalData(),
      ]);
      const postcodes = getPostcodesWithinRadius(
        postalData,
        position.coords.latitude,
        position.coords.longitude,
        NEARBY_RADIUS_KM,
      );

      if (!postcodes.length) throw new Error("NO_NEARBY_POSTCODE");

      setPreviousInterventionAreas(
        Array.isArray(filter.filter.interventionAreas)
          ? filter.filter.interventionAreas
          : [],
      );
      SetFilter((previousFilter) => ({
        ...previousFilter,
        filter: {
          ...previousFilter.filter,
          interventionAreas: postcodes,
        },
      }));
      setSearchTerm("");
      setNearbyStatus("active");
    } catch (error) {
      setNearbyStatus("error");
      setNearbyError(
        error?.code === 1
          ? "Autorisez la localisation pour utiliser la recherche autour de vous."
          : "Impossible de déterminer les prestataires dans un rayon de 10 km.",
      );
    }
  };

  const toggleNearbySearch = () => {
    if (nearbyStatus === "active") {
      disableNearbySearch();
    } else if (nearbyStatus !== "loading") {
      enableNearbySearch();
    }
  };

  if (isMeLoading || isLoadCat || isLoadSectors) {
    return <Loader />;
  }
  if (
    isErrorSector ||
    isError ||
    isErrorCat ||
    isErrorSubCat
  ) {
    return <Navigate to={"/"} />;
  }
  return (
    <>
      <div className="w-full grid lg:grid-cols-4 gap-6 ">
        <div className="w-full h-fit bg-white rounded-2xl hidden lg:block sticky top-[90px]  ">
          <div
            className="w-full h-[84px] bg-cover bg-center rounded-t-xl relative "
            style={{backgroundImage: `url('${BgPattern}')`}}
          >
            <div className="absolute -bottom-12 rounded-md left-[50%] -translate-x-[50%]">
              <div className="relative">
                <Link
                  to={"/mon-profil/#avis"}
                  className="bg-[#FFC107] w-1/2 flex justify-center gap-[2px] items-center leading-none p-[1px] text-white text-[12px] absolute bottom-0 rounded-md left-[50%] -translate-x-[50%] "
                >
                  {Number(data?.avgRating).toFixed(2)}
                  <StarIcon className="fill-white stroke-none w-3 h-3" />
                </Link>
                {/* <div className="absolute w-6 h-6 bg-white flex justify-center items-center top-1 right-1 text-[#1A64B9] rounded-full">
                  <img className="w-4" src={Crown} alt="" title="Professionnel" />{" "}
                </div> */}
                <ImageComponent
                  src={buildImageUrl(data?.imageUri)}
                  alt=""
                  className=" w-[104px] h-[104px] rounded-full object-cover ring-4 ring-white"
                  fallback={
                    <img
                      src={NoProfile}
                      alt=""
                      className=" w-[104px] h-[104px] rounded-full object-cover ring-4 ring-white"
                      width="130"
                    />
                  }
                />
              </div>
            </div>
          </div>
          <div className="flex flex-col justify-start items-center mt-5">
            <Link
              to={"/mon-profil"}
              className="text-center text-[#19295C] font-semibold capitalize "
            >
              {`${data.lastName}  ${data.firstName}`}
            </Link>
            <div className="text-center text-primary font-normal text-sm">
              {"Client"}
            </div>

            <Link
              to="/deposer-une-annonce"
              className="w-full flex justify-start gap-[12px] items-center cursor-pointer text-xl text-[#6B6B6B] border-t border-b border-solid border-[#D6E2EF] px-4 py-3 group hover:text-[#FF6600] mt-3 "
            >
              <i className="fi fi-rr-multiple flex items-center"></i>
              <span className="font-semibold text-[14px] text-[#9B9B9B] group-hover:text-[#FF6600] ">
                Créer une annonce
              </span>
            </Link>
            <Link
              to={"/mon-profil"}
              className="w-full flex justify-start gap-[12px] items-center cursor-pointer text-2xl text-[#6B6B6B] group hover:text-[#FF6600] px-4 py-3 "
            >
              <i className="fi fi-rr-user flex justify-center items-center group-hover:text-[#FF6600]"></i>
              <span className="font-semibold text-[15px] text-[#9B9B9B] group-hover:text-[#FF6600]  ">
                Mon profil
              </span>
            </Link>
          </div>
        </div>
        <div className="w-full col-span-2 flex flex-col  px-4 lg:!px-0 justify-start items-center gap-3">
          <div className="w-full flex flex-col gap-4">
            <div className="w-full flex flex-wrap sm:flex-nowrap items-stretch gap-2">
              <AutoComplete
                setsearchValue={setsearchValue}
                groupedSuggestions={groupSearch}
                setFilter={SetFilter}
                isLoadingSuggestions={isLoadingPres}
              />

              <button
                type="button"
                aria-pressed={nearbyStatus === "active"}
                aria-label={t("nearMe")}
                disabled={nearbyStatus === "loading"}
                className={`h-[52px] min-h-[52px] px-4 flex justify-center items-center gap-2 rounded-full text-sm font-semibold border border-solid transition-colors whitespace-nowrap ${
                  nearbyStatus === "active"
                    ? "text-white bg-[#1a64b9] border-[#1a64b9]"
                    : "text-[#19295C] bg-white border-[#D6E2EF]"
                } ${
                  nearbyStatus === "loading"
                    ? "opacity-70 cursor-wait"
                    : "cursor-pointer"
                }`}
                onClick={toggleNearbySearch}
              >
                <i
                  className={`fi fi-rr-location-crosshairs flex justify-center items-center ${
                    nearbyStatus === "loading" ? "animate-spin" : ""
                  }`}
                ></i>
                <span>{t("nearMe")}</span>
                <span
                  className={`text-xs ${
                    nearbyStatus === "active"
                      ? "text-white"
                      : "text-[#7E7E7E]"
                  }`}
                >
                  10 km
                </span>
              </button>
            </div>
            {nearbyError && (
              <div className="w-full text-xs text-red-500 -mt-2 px-2">
                {nearbyError}
              </div>
            )}
            {/* <div
              className={`transform transition-all duration-300 ${
                filterBut
                  ? "opacity-100 h-fit translate-y-0"
                  : "opacity-0  h-0 -translate-y-5 hidden"
              }`}
            > */}
            <FilterPrestataire
              setFilter={SetFilter}
              filter={filter}
              searchTerm={searchTerm}
              setSearchTerm={setSearchTerm}
              isNearbyActive={nearbyStatus === "active"}
              className={"w-full"}
            />
            {/* </div> */}
            <div className="w-full flex justify-between items-center gap-4 flex-wrap-reverse">
              <div className="text-[#19295C] font-bold text-base sm:text-lg 2xl:text-xl">
                {t("providerList")}
              </div>
              <div className="flex items-center gap-2">
                <div className="text-[#7E7E7E] font-medium text-xs">
                  {t("sortBy")}
                </div>
                <Dropdown>
                  <DropdownToggle
                    variant=""
                    className=" i-false !p-0 w-full flex !flex-row items-center gap-2 "
                  >
                    <div className="flex items-center justify-between gap-2 w-full p-2 bg-white border rounded-lg border-solid border-[#E2E2E2]">
                      <span className="text-[#19295C] font-medium text-sm">
                        {t(selectedTri.titleKey)}
                      </span>
                      <i className="fi fi-rr-angle-small-down flex items-center"></i>
                    </div>{" "}
                  </DropdownToggle>
                  <DropdownMenu
                    align="right"
                    className=" w-[230px] p-0 !rounded-md !overflow-y-scroll max-h-[250px] overflow-style-none "
                  >
                    {TriOptions.map((option) => (
                      <Dropdown.Item
                        className="!flex !items-center !gap-2 !cursor-pointer !p-2 !border-b !font-medium !text-sm !text-[#19295C] hover:!bg-[#E2F0FF]"
                        key={option.value}
                        onClick={() => {
                          SetFilter((prevFilter) => ({
                            ...prevFilter,
                            order: option.value + "_" + option.defaultOrder,
                          }));
                          setSelectedTri(option);
                          setSelectedOrder(option.defaultOrder);
                        }}
                      >
                        {t(option.titleKey)}
                      </Dropdown.Item>
                    ))}
                  </DropdownMenu>
                </Dropdown>
                {selectedOrder === "ASC" ? (
                  <img
                    onClick={() => {
                      SetFilter((prevFilter) => ({
                        ...prevFilter,
                        order: selectedTri.value + "_DESC",
                      }));
                      setSelectedOrder("DESC");
                    }}
                    src={arrowTri}
                    alt="Trier par ordre décroissant"
                    className="w-[15px] rotate-180 cursor-pointer"
                  />
                ) : (
                  <img
                    onClick={() => {
                      SetFilter((prevFilter) => ({
                        ...prevFilter,
                        order: selectedTri.value + "_ASC",
                      }));
                      setSelectedOrder("ASC");
                    }}
                    src={arrowTri}
                    alt="Trier par ordre croissant"
                    className="w-[15px] cursor-pointer "
                  />
                )}
              </div>
            </div>

            <ListPrestataires filter={filter} />
          </div>
        </div>

        <div className="w-full hidden h-fit lg:flex flex-col gap-4 sticky top-[90px] ">
          <Weather />
          <div className="w-full rounded-2xl  bg-white flex flex-col text-[#19295C] font-bold text-xl ">
            <div className="w-full flex items-start justify-between p-3">
              <span className="font-semibold text-lg">
                Interventions à venir
              </span>
              <Link to={"/interventions"}>
                <img src={arrow} className="cursor-pointer" alt="" />
              </Link>
            </div>
            {isLoading && <Loader />}
            {isError && (
              <div className="p-4 text-red text-center">
                "Oups ! Un problème est survenu lors de la récupération des
                données. Veuillez vérifier votre connexion ou réessayer plus
                tard."
              </div>
            )}
            {interventions && !!interventions.length ? (
              interventions.map((intervention) => (
                <InterventionItem
                  key={intervention.id}
                  intervention={intervention}
                  className={"border-b border-solid border-[#D6E2EF] "}
                />
              ))
            ) : (
              <div className="text-center py-3 font-medium text-base text-[#7e7e7e]">
                Pas d'interventions.
              </div>
            )}
          </div>

          <PubList />
        </div>
      </div>
    </>
  );
};

export default RecherchePrestataires;
